export default __webpack_public_path__ + "media/images/borders/white-border-4c9329065fe7fc371c65fe255b08b719.svg";